<template>
    <!-- 司机-有效司机导出 -->
    <div class="handle-box-search">
        <div class="handle-box-search">
            <!-- 原导出功能 -->
            <!-- <el-row type="flex" justify="center" align="middle" style="margin-bottom: 20px;">

                <span style="display: inline-block;width: 70px;text-align: right; margin-right: 5px;">密码:</span>
                <el-input v-model="submit_data.export_password" style="width: 200px;" show-password></el-input>



            </el-row>





            <div style="width: 500px; margin: 10px auto;" v-if="progress_show">

                <el-progress :percentage="progress_data"></el-progress>
                <i class="el-icon-loading"></i>
                正在导出...

            </div>

            <el-row type="flex" justify="center" v-else>

                <el-button type="primary" @click="toExport">导出</el-button>


            </el-row> -->
            <div style="display: flex">
                <div
                    style="background-color: #05C0AB; display: inline-block; width: 6px; height: 20px; margin-top: 20px; margin-right: 5px"
                ></div>
                <span style="display: inline-block; margin-top: 20px">三个月有效司机变化图</span>
            </div>

            <div class="monthCharts-box" style="width: 100%">
                <div id="monthCharts" style="height: 400px"></div>
                <div class="monthCharts-bg" style="height: 400px;text-align: center" v-show="!echars_loading">
                    <span class="el-icon-loading"></span>
                    <p>正在请求中...</p>
                </div>
            </div>
        </div>
        <div class="handle-box-search">
            <!-- 有效司机 查询&导出 -->
            <div>
                <div style="display: flex">
                    <div
                        style="
                            background-color: #05C0AB;
                            display: inline-block;
                            width: 6px;
                            height: 20px;
                            margin-top: 20px;
                            margin-right: 5px;
                        "
                    ></div>
                    <span style="display: inline-block; margin-top: 20px">有效司机 查询&导出</span>
                </div>
                <div class="handle-box">
                    <el-row class="head-search">
                        <el-col :span="24" style="margin-top: 10px">
                            <span class="title">创建时间:</span>

                            <el-date-picker
                                v-model="search_time"
                                type="date"
                                placeholder="选择日期"
                                @change="timeChange"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerOptions1"
                            >
                            </el-date-picker>
                        </el-col>
                    </el-row>
                    <!-- <el-row class="head-search">
                    <el-col :span="24" style="margin-top: 10px;">
                        <span class="title">创建时间:</span>

                        <el-date-picker v-model="search_time" type="datetimerange" range-separator="-"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss" @change="timeChange" style="width: 300px;">
                        </el-date-picker>
                    </el-col>
                </el-row> -->
                </div>
                <el-button type="primary" icon="el-icon-search" @click="searchGetDriverCountList">查询</el-button>
                <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
                <el-button v-if="loading" icon="el-icon-loading" disabled></el-button>
                <el-button icon="el-icon-setting" @click="toExport" v-else>导出</el-button>
                <div style="width: 500px; margin: 10px auto" v-if="progress_show">
                    <el-progress :percentage="progress_data"></el-progress>
                    <i class="el-icon-loading"></i>
                    正在导出...
                </div>
                <div style="margin: 20px; display: flex; justify-content: left">
                    <div style="margin-right: 20px">总有效司机人数：{{ driver_count }}</div>
                    <div style="margin-right: 20px">包月司机人数：{{ full_time_count }}</div>
                    <div style="margin-right: 20px">包天司机人数：{{ part_time_count }}</div>
                    <div style="margin-right: 20px">按单司机人数：{{ single_count }}</div>
                </div>
                <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header">
                    <!-- <el-table-column type="selection" width="55">
            </el-table-column> -->
                    <el-table-column prop="id" label="id" min-width="130"> </el-table-column>

                    <el-table-column label="真实姓名" prop="real_name" min-width="130"> </el-table-column>
                    <el-table-column label="签约类型" prop="signing_type" min-width="130"></el-table-column>

                    <el-table-column label="工作类型" prop="work_type" min-width="130"></el-table-column>
                    <el-table-column label="职位" prop="capacity" min-width="130"></el-table-column>
                    <el-table-column label="城市小组" prop="city_group_name" min-width="130"></el-table-column>
                    <el-table-column label="司机电话" prop="phone" min-width="130"> </el-table-column>

                    <el-table-column label="签约时间" prop="last_signing_time" min-width="100"></el-table-column>
                    <el-table-column label="到期时间" prop="signing_end_time_stamp" min-width="100"></el-table-column>
                    <el-table-column label="首次签约时间" prop="first_signing_time" min-width="100"> </el-table-column>
                    <el-table-column label="司机综合分数" prop="exponentDriverPoints" min-width="100"> </el-table-column>
                    <el-table-column label="表现分" prop="monitor_point" min-width="100"> </el-table-column>
                    <el-table-column label="身份证号" prop="id_card" min-width="100">
                        <template slot-scope="scope">
                            {{ scope.row.id_card ? scope.row.id_card.replace(/^(.{4})(?:\w+)(.{4})$/, '\$1********\$2') : '' }}
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 分页组件 -->
                <div class="pagination">
                    <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
var _this;
import echarts from 'echarts';
export default {
    data() {
        return {
            pickerOptions1: {
                disabledDate(time) {
                    var thatDay = time.getTime();
                    // console.log(thatDay,'--------');

                    // _this.default_value = new Date(threeMonths)

                    // 点击时间控件打开的图形中显示时间如果 等于 当前日期，禁用，不可选择
                    // console.log(Date.now());
                    return thatDay > Date.now(); //默认今天凌晨数据
                }
            },
            echars_loading: false,
            // 三个月有效司机变化图
            monthCharts: '',
            monthOption: {
                title: {
                    // text: '三个月有效司机变化图'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['有效司机人数', '包月司机数', '包天司机数', '按单司机数']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {},
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: []
                },
                yAxis: {
                    type: 'value',
                    minInterval: 1
                    // scale:true
                },
                series: [
                    {
                        name: '有效司机人数',
                        type: 'line',
                        data: [],
                        smooth: true,
                        color: '#409eff'
                    },
                    {
                        name: '包月司机数',
                        type: 'line',
                        data: [],
                        smooth: true,
                        color: '#66dfe2'
                    },
                    {
                        name: '包天司机数',
                        type: 'line',
                        data: [],
                        smooth: true,
                        color: '#9ee7b7'
                    },
                    {
                        name: '按单司机数',
                        type: 'line',
                        data: [],
                        smooth: true,
                        color: '#df60ad'
                    }
                ]
            },

            result_data: [],
            driver_count: '',
            full_time_count: '',
            part_time_count: '',
            single_count: '',

            loading: false,
            // 存放表格数据
            tableData: [],
            //获取用户列表的数据
            search_data: {
                page: 1,
                limit: 10,
                type:0,
                fixed_time: ''
            },
            search_rules: {
                fixed_time: {
                    placeholder: '日期',
                    rules: {
                        required: false,
                        message: '日期不能为空',
                        regulation: 'gt',
                        rulesData: 0
                    }
                }
            },

            search_time: '',
            submit_data: {
                page: 1,
                export_password: ''
            },

            excelData: [],

            excelHead: [],

            progress_show: false,
            progress_data: 0
        };
    },
    created() {
        _this = this;
    },
    mounted() {
        _this.monthEchartsInit();

        _this.echartsInit();
    },

    methods: {
        monthEchartsInit() {
            _this.monthOption.xAxis.data = [];

            _this.monthOption.series[0].data = [];

            _this.monthOption.series[1].data = [];

            _this.monthOption.series[2].data = [];

            _this.monthOption.series[3].data = [];

            _this.echars_loading = false;

            _this.getData();
        },

        getData() {
            _this
                .$post('/statistics/getDriverBarChartCount', {})
                .then((res) => {
                    _this.echars_loading = true;

                    for (let i = 0; i < res.data.list.length; i++) {
                        // 日期
                        _this.monthOption.xAxis.data.push(res.data.list[i].dateTime);
                        //总有效司机人数
                        _this.monthOption.series[0].data.push(Number(res.data.list[i].driver_count));
                        // 包月司机人数
                        _this.monthOption.series[1].data.push(Number(res.data.list[i].full_time_count));

                        // 包天司机人数
                        _this.monthOption.series[2].data.push(Number(res.data.list[i].part_time_count));
                        //按单
                        _this.monthOption.series[3].data.push(Number(res.data.list[i].single_count));
                    }
                    // console.log(_this.monthOption, '_this.monthOption');

                    _this.echartsInit();
                })
                .catch((err) => {});
        },
        // echarts渲染
        echartsInit() {
            this.monthCharts = echarts.init(document.getElementById('monthCharts'));
            this.monthCharts.setOption(_this.monthOption);
            // 浏览器缩放，图表等比例缩放
            window.addEventListener("resize", function () {
              _this.monthCharts.resize();

            });
        },
        searchGetDriverCountList() {
            _this.search_data.page = 1;
            _this.search_data.type = 0;
            _this.getDriverCountList();
        },

        getDriverCountList() {
            if (_this.search_data.fixed_time == '') {
                this.$message.error('查询时间不能为空');
                return;
            }
            _this
                .$post('/statistics/getDriverCountList', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data.result;
                    _this.result_data = res.data;
                    _this.driver_count = res.data.driver_count;
                    _this.full_time_count = res.data.full_time_count;
                    _this.part_time_count = res.data.part_time_count;
                    _this.single_count = res.data.single_count;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.getDriverCountList();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        },

        timeChange(val) {
            // console.log('qqq');
            // console.log(val);
            // console.log(_this.search_time, 'search_time');

            if (val != null) {
                // _this.search_data.fixed_time = JSON.stringify(['between', ..._this.search_time]);
                _this.search_data.fixed_time = JSON.stringify([_this.search_time]);
            } else {
                _this.search_data.fixed_time = '';
            }
        },
        toExport() {
            if (_this.search_data.fixed_time == '') {
                this.$message.error('查询时间不能为空');
                return;
            }
            _this.search_data.page = 1;
            _this.loading = true;
            _this.getExcelData();
        },

        // getExcelData() {
        //     _this
        //         .$post('/order/getDriverTrueCSV', _this.submit_data)
        //         .then((res) => {
        //             _this.progress_show = true;

        //             if (this.$route.path == '/getDriverTrueCSV') {
        //                 // 导出excel的空数组中添加数据
        //                 for (let i = 0; i < res.data.list.length; i++) {
        //                     _this.excelData.push({
        //                         phone: res.data.list[i].phone,
        //                         real_name: res.data.list[i].real_name,
        //                         time: res.data.list[i].time,
        //                         signing_time: res.data.list[i].signing_time,
        //                         capacity: res.data.list[i].capacity,
        //                         driver_or_legwork: res.data.list[i].driver_or_legwork,
        //                         name: res.data.list[i].name,
        //                         signing_type: res.data.list[i].signing_type,
        //                         exponentDriverPoints_: res.data.list[i].exponentDriverPoints_,
        //                         id_card: res.data.list[i].id_card
        //                     });
        //                 }

        //                 if (res.data.page * res.data.limit < res.data.count) {
        //                     _this.submit_data.page = res.data.page + 1;

        //                     _this.progress_data = Math.floor(((res.data.page * res.data.limit) / res.data.count) * 100);

        //                     _this.getExcelData();
        //                 } else {
        //                     // console.log(_this.excelData);

        //                     // 将数据导出execl
        //                     _this.exportData();

        //                     _this.submit_data.page = 1;

        //                     // 清空数据
        //                     _this.excelData = [];

        //                     _this.progress_show = false;
        //                     _this.progress_data = 0;
        //                 }
        //             } else {
        //                 _this.progress_show = false;
        //                 _this.progress_data = 0;
        //             }
        //         })
        //         .catch((err) => {});
        // },

        // // 导出excel方法
        // exportData() {
        //     const { export_json_to_excel } = require('@/vendor/Export2Excel');
        //     const tHeader = [
        //         '真实姓名',
        //         '签约类型',
        //         '工作类型',
        //         '职位',
        //         '城市小组',
        //         '司机电话',
        //         '到期时间',
        //         '签约时间',
        //         '司机综合分数',
        //         '身份证'
        //     ];
        //     const filterVal = [
        //         'real_name',
        //         'signing_type',
        //         'driver_or_legwork',
        //         'capacity',
        //         'name',
        //         'phone',
        //         'time',
        //         'signing_time',
        //         'exponentDriverPoints_',
        //         'id_card'
        //     ];
        //     const list = this.excelData;
        //     const data = this.formatJson(filterVal, list);
        //     export_json_to_excel(tHeader, data, 'fileName');
        // },

        // formatJson(filterVal, jsonData) {
        //     return jsonData.map((v) => filterVal.map((j) => v[j]));
        // }
        getExcelData() {
            this.search_data.type = 1;
            _this
                .$post('/statistics/getDriverCountList', _this.search_data)
                .then((res) => {
                    _this.progress_show = true;
                    _this.loading = false;
                    // console.log('getExcelData');
                    console.log(res.data.result,'res.data.result');

                    if (this.$route.path == '/getDriverTrueCSV') {
                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.result.length; i++) {
                            _this.excelData.push({
                                real_name: res.data.result[i].real_name,
                                signing_type: res.data.result[i].signing_type,
                                work_type: res.data.result[i].work_type,
                                capacity: res.data.result[i].capacity,
                                city_group_name: res.data.result[i].city_group_name,
                                phone: res.data.result[i].phone,
                                last_signing_time: res.data.result[i].last_signing_time,
                                signing_end_time_stamp: res.data.result[i].signing_end_time_stamp,
                                first_signing_time: res.data.result[i].first_signing_time,
                                exponentDriverPoints: res.data.result[i].exponentDriverPoints,
                                monitor_point: res.data.result[i].monitor_point,
                                id_card: res.data.result[i].id_card
                            });
                        }

                        if (res.data.page * res.data.limit < res.data.count) {
                            _this.search_data.page = res.data.page + 1;

                            _this.progress_data = Math.floor(((res.data.page * res.data.limit) / res.data.count) * 100);

                            _this.getExcelData();
                        } else {
                            // console.log(_this.excelData);

                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;
                            _this.progress_data = 0;
                        }
                    } else {
                        _this.progress_show = false;
                        _this.progress_data = 0;
                    }
                })
                .catch((err) => {});
        },

        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = [
                '真实姓名',
                '签约类型',
                '工作类型',
                '职位',
                '城市小组',
                '司机电话',
                '签约时间',
                '到期时间',
                '首次签约时间',
                '司机综合分数',
                '表现分',
                '身份证号'
            ];
            const filterVal = [
                'real_name',
                'signing_type',
                'work_type',
                'capacity',
                'city_group_name',
                'phone',
                'last_signing_time',
                'signing_end_time_stamp',
                'first_signing_time',
                'exponentDriverPoints',
                'monitor_point',
                'id_card'
            ];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, 'fileName');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        }
    }
};
</script>

<style scoped>
.handle-box-search {
    background-color: #fff !important;
}
.monthCharts-box {
    position: relative;
}
.monthCharts-box {
    position: relative;
}
.monthCharts-bg {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.2);
    color: #fff;
}
</style>
